<template>
  <el-dialog :title="dialogTitle" :visible.sync="editContentFormVisible" class="dialog_block" width="600" height="500" :close-on-click-modal="false">
    <el-form
      :model="contentForm"
      :rules="rules"
      ref="contentForm"
      label-width="100px"
      class="demo-dynamic"

    >
      <el-form-item label="工作内容" prop="">
        <!-- <el-input v-model="contentForm.tips" type="textarea"></el-input> -->
        <textarea v-model="contentForm.tips" prefix-icon="el-icon-tickets" class="pro_bz mb_7" placeholder="请输入工作内容"></textarea>
      </el-form-item>
      <el-form-item label="图片(选填)" prop="imgPaths" class="mb_25">
        <el-upload
          ref="imgUpload"
          :action="'/files/fileUpload'|getBaseApiUrl"
          :limit="9"
          :data="uploadData"
          :on-exceed="uploadImgExceed"
          :before-upload="uploadImgBefore"
          :file-list="imgList"
          list-type="picture-card"
          :on-success="imagePathsSuccess"
          multiple
          :accept="'image/*'"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <!-- <div slot="tip" class="el-upload__tip">支持jpg,jpeg,bmp,gif,png格式照片，大小不超过8M，最多上传9张图片</div> -->
        </el-upload>
      </el-form-item>
      <el-form-item label="视频(选填)" prop="videoPaths" class="mb_25">
        <el-upload
          ref="videoUpload"
          :action="'/files/fileUpload'|getBaseApiUrl"
          :before-upload="uploadvideoBefore"
          :on-success="videoPathsSuccess"
          :show-file-list="false"
          :data="uploadData"
          list-type="picture-card"
          :accept="'video/*'"
          v-loading="videoUploadloading"
          element-loading-text="拼命上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.6)"
        >
          <video
            style="float:left;"
            width="125px"
            height="125px"
            v-if="videoPath"
            :src="videoPath|getBaseImgUrl"
            controls="controls"
          >您的浏览器不支持视频播放</video>
          <i class="el-icon-plus" v-else></i>
          <!-- <div slot="tip" class="el-upload__tip">支持mp4,avi格式视频，大小不超过100M，最多上传1个视频</div> -->
        </el-upload>
      </el-form-item>
    </el-form>
    <hr>
    <div class="foot_span">
      <el-button class="borderbtn width_80 fz_12" @click="save(1)">保存</el-button>
      <el-button class="blockbtn width_80 fz_12" @click="save(2)">继续添加</el-button>
      <!-- <el-button @click="close">取 消</el-button> -->
    </div>
  </el-dialog>
</template>

<script>
import { companytable } from "@/const/asset/user";
import { objKeySort } from "@/util/ajaxsign";
import { apiLink, getImgLink } from "@/config/env";
export default {
  name: "editContent",
  data() {
    return {
      videoUploadloading:false,
      imgUploadloading:false,
      editContentFormVisible: false,
      dialogTitle: "添加工作内容",
      uploadData: {},
      contentForm: {
        id: "",
        tips: "",
        imgPaths: "",
        imgCount: 0,
        videoPaths: "",
        videoCount: 0
      },
      imgList: [],
      videoPath: "",
      rules: {
        tips: [{ required: true, message: "请填写工作内容", trigger: "blur" }]
      }
    };
  },
  created() {
    this.uploadData = objKeySort({});
    console.log(this.uploadData);
  },
  filters: {
    dataFormat: function(dateStr) {
      return dateY(dateStr);
    },
    getBaseApiUrl: function(uri) {
      if (uri) {
        return apiLink(uri);
      } else {
        return "";
      }
    },
    getBaseImgUrl: function(uri) {
      console.log(uri);
      if (uri) {
        return getImgLink(uri);
      } else {
        return "";
      }
    }
  },
  methods: {
    uploadImgBefore(file) {
      let isImg = false;
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/bmp" ||
        file.type == "image/jpg" ||
        file.type == "image/gif"
      ) {
        isImg = true;
      }
      const isLt8M = file.size / 1024 / 1024 < 8;
      if (!isImg) {
        this.$message.error("上传图片只能是jpg,jpeg,bmp,gif,png格式照片!");
      }
      if (!isLt8M) {
        this.$message.error("上传图片大小不能超过 8MB!");
      }
      if(isImg && isLt8M){
        this.imgUploadloading = true;
        return true;
      }else{
        return false;
      }

    },
    uploadvideoBefore(file) {
      let isvideo = false;
      if (file.type == "video/mp4" || file.type == "video/avi") {
        isvideo = true;
      }
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isvideo) {
        this.$message.error("上传视频只能是MP4,AVI格式视频文件!");
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小不能超过 100MB!");
      }
      if(isvideo && isLt100M){
        this.videoUploadloading = true;
        return true;
      }else{
        return false;
      }
    },

    //文件变化
    imagePathsSuccess(res) {
      if (res.code != 200) {
        this.$message.warning("文件上传失败，请联系平台");
        this.$refs.imgUpload.uploadFiles=[];
      }
      this.imgUploadloading = false;
    },
    videoPathsSuccess(res) {
      this.videoUploadloading = false;
      if (res.code != 200) {
        this.$message.warning("文件上传失败，请联系平台");
        return;
      }
      this.contentForm.videoPaths = "";
      this.contentForm.videoCount = 0;
      this.videoPath = "";
      if (res.data && res.data.filePath) {
        this.videoPath = res.data.filePath;
        this.contentForm.videoPaths = res.data.filePath;
        this.contentForm.videoCount = 1;
      }

    },
    uploadImgExceed(files, fileList) {
      this.$message.warning(
        `照片最多只能上传9张`
      );
    },
    uploadvideoExceed(files, fileList) {
      this.$message.warning(
        `视频最多只能上传3个`
      );
    },
    setData(data) {
      this.editContentFormVisible = true;
      this.cleanForm();
      if (data) {
        this.contentForm = data;
        this.dialogTitle = "修改工作内容";
        if (data.imgPaths) {
          data.imgPaths.split(",").forEach(path => {
            this.imgList.push({ url: getImgLink(path) });
          });
        }
        if (data.videoPaths) {
          data.videoPaths.split(",").forEach(path => {
            this.videoPath = path;
          });
        }
      } else {
        this.dialogTitle = "添加工作内容";
        this.cleanForm();
      }
    },
    save(type) {
       let that =this
      that.$refs.contentForm.validate(valid => {
        if(that.contentForm.tips.trim()==''){
          that.$notify({
           title: '温馨提示',
           message: '请输入工作内容描述',
           type: 'warning',
           duration: 3000
         });
         return false
        }
        if (valid) {
          that.initContentImg();
          that.$emit("setContent", that.contentForm);
          if (type == 1) {
            that.close();
          } else {
            that.cleanForm();
          }
        } else {
          return false;
        }
      });
    },
    initContentImg() {
      const fileList = this.$refs.imgUpload.uploadFiles;
      this.contentForm.imgPaths = "";
      this.contentForm.imgCount = 0;
      if (fileList && fileList.length > 0) {
        this.contentForm.imgCount = fileList.length;
        fileList.forEach(f => {
          if ((f.response && f.response.data.filePath) || f.url) {
            if (this.contentForm.imgPaths) {
              this.contentForm.imgPaths = this.contentForm.imgPaths + ",";
            }
            this.contentForm.imgPaths =
              this.contentForm.imgPaths +
              (f.response ? f.response.data.filePath : f.url).replace(
                new RegExp(getImgLink(""), "g"),
                ""
              );
          }
        });
      }
      // const imgUrl = getImgLink("");
      // console.log(imgUrl);
      // this.contentForm.imgPaths = this.contentForm.imgPaths.replace(new RegExp(imgUrl,'g'),"");
      console.log(fileList, this.contentForm);
    },
    close() {
      this.editContentFormVisible = false;
      this.cleanForm();
    },
    cleanForm() {
        // this.$refs.contentForm.resetFields();
        if(this.$refs.contentForm&&this.$refs.imgUpload&&this.$refs.videoUpload){
        this.$refs.contentForm.clearValidate();
        this.$refs.imgUpload.clearFiles();
        this.$refs.videoUpload.clearFiles();
        this.imgList = [];
        this.videoPath = "";
        this.contentForm = {
          id: "",
          tips: "",
          imgPaths: "",
          imgCount: 0,
          videoPaths: "",
          videoCount: 0
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .mb_7{
    margin-bottom: 7px;
  }
  .width_80{
    width: 80px;
    margin-top: 0;
  }
  .el-button{
   padding: 1px 16px;
  }
  .el-loading-parent--relative{
    /deep/ .el-loading-mask{
      width: 125px !important;
    }
  }

  .el-upload--picture-card{
    width: 125px;
    height: 125px;
    border-radius:3px;
    border:1px solid rgba(237,239,242,1);
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }
  .el-upload-list__item{
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .foot_span{
    text-align: right;
    margin-right: 56px;
  }
  hr {
    bottom: 72px;
    border-color: rgba(245, 247, 250, 0.2);
    margin-bottom: 15px;
  }
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-upload-list__item:first-child{
    margin-top: 0 !important;
  }
</style>
